import BannerLaboratory from './BannerLaboratory'

export default BannerLaboratory
